/**
 * WorkspaceIcon — resolve icon lucide-react theo tên string trong nav config.
 *
 * Tránh import tĩnh từng icon: dùng bảng tra cứu các icon thực sự dùng trong
 * workspace để tree-shaking vẫn loại bỏ phần còn lại của lucide.
 */

import React from 'react';
import {
  LayoutGrid,
  LayoutDashboard,
  Users,
  BookOpen,
  FolderOpen,
  Sparkles,
  FileQuestion,
  ClipboardList,
  GraduationCap,
  PieChart,
  Route,
  Bot,
  Languages,
  Compass,
  Target,
  TrendingUp,
  ChartPie,
  LineChart,
  Award,
  CalendarCheck,
  FileText,
  MessageSquare,
  Presentation,
  Video,
  FlaskConical,
  PencilLine,
  StickyNote,
  Mic,
  Gamepad2,
  Atom,
  MonitorPlay,
  Lightbulb,
  Box,
  Image,
  Landmark,
  BookText,
  Table2,
  BarChart3,
  Mail,
  Library,
  LayoutTemplate,
  CalendarDays,
  BrainCircuit,
  Scale,
  ShieldCheck,
  Dices,
  Smile,
  Play,
  MoreHorizontal,
  LogOut,
  Settings,
  House,
  CalendarRange,
  Briefcase,
  NotebookPen,
  Bell,
  Activity,
  type LucideProps,
} from 'lucide-react';

const ICONS: Record<string, React.ComponentType<LucideProps>> = {
  LayoutGrid,
  LayoutDashboard,
  Users,
  BookOpen,
  FolderOpen,
  Sparkles,
  FileQuestion,
  ClipboardList,
  GraduationCap,
  PieChart,
  Route,
  Bot,
  Languages,
  Compass,
  Target,
  TrendingUp,
  ChartPie,
  LineChart,
  Award,
  CalendarCheck,
  FileText,
  MessageSquare,
  Presentation,
  Video,
  FlaskConical,
  PencilLine,
  StickyNote,
  Mic,
  Gamepad2,
  Atom,
  MonitorPlay,
  Lightbulb,
  Box,
  Image,
  Landmark,
  BookText,
  Table2,
  BarChart3,
  Mail,
  Library,
  LayoutTemplate,
  CalendarDays,
  BrainCircuit,
  Scale,
  ShieldCheck,
  Dices,
  Smile,
  Play,
  MoreHorizontal,
  LogOut,
  Settings,
  House,
  CalendarRange,
  Briefcase,
  NotebookPen,
  Bell,
  Activity,
};

interface WorkspaceIconProps extends LucideProps {
  name: string;
}

export const WorkspaceIcon: React.FC<WorkspaceIconProps> = ({ name, ...props }) => {
  const Cmp = ICONS[name] || LayoutGrid;
  return <Cmp {...props} />;
};
